import React from 'react';
import { Box, Typography } from '@mui/material';
import Header from '../../../src/components/Header';
import Footer from '../../../src/components/Footer';
import ProfileTabs from './ProfileTabs';

function Profile() {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                backgroundColor: '#ffffff', // White background
            }}
        >
            {/* Header */}
            <Header />

            {/* Content */}
            <Box
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '2rem',
                }}
            >
                {/* Page Title */}
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 'bold',
                        marginBottom: '2rem',
                        textAlign: 'center',
                        color: 'text.primary',
                    }}
                >
                    My Profile
                </Typography>

                {/* Tab Navigation */}
                <Box sx={{ width: '100%', maxWidth: '800px', marginBottom: '2rem' }}>
                    <ProfileTabs />
                </Box>
            </Box>

            {/* Footer */}
            <Footer />
        </Box>
    );
}

export default Profile;
